import React from "react";
import styles from "./Toggle.module.scss";

const Toggle = ({
  checked,
  onChange,
  onLabel = "ON",
  offLabel = "OFF",
  id = "toggle-switch",
}) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onChange(!checked);
    }
  };

  return (
    <div className={styles.toggle}>
      {/* Hidden checkbox for accessibility */}
      <input
        id={id}
        type="checkbox"
        className={styles.toggleInput}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        aria-checked={checked}
        role="switch"
      />

      {/* Styled label */}
      <label
        htmlFor={id}
        className={`${styles.toggleLabel} ${
          checked ? styles.isOn : styles.isOff
        }`}
        tabIndex={0}
        onKeyDown={handleKeyDown}
      >
        <span className={styles.track}>
          <span className={styles.thumb} />
        </span>

        <span className={styles.toggleText} aria-hidden="true">
          {checked ? onLabel : offLabel}
        </span>
      </label>
    </div>
  );
};

export default Toggle;